import TariffChangeTable from "./tariff-change-table";

export default TariffChangeTable;
